import { render, staticRenderFns } from "./editCompleteOrder.vue?vue&type=template&id=15d56432&"
import script from "./editCompleteOrder.vue?vue&type=script&lang=js&"
export * from "./editCompleteOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports